import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { handleResponseCode } from "../../../../app/utilities/helpers";
import GetProxy from "../../../../app/GetProxy";

const cookies = new Cookies();
const proxy = GetProxy();

export const businessInfoList = createAsyncThunk(
  "post/businessInfoList",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/businessInfoConfig/list/BusinessInfoConfigDetailsList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const AppList = createAsyncThunk("post/getDatasApp", async (props) => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const { userName, userRole } = props;
    const response = await fetch(`${proxy}/cmdb/${userName}/${userRole}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "DTOP-API-TOKEN": apiToken,
        USERNAME: username,
      },
    });
    handleResponseCode(response);
    const data = await response.json();
    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("error:", error);
    throw error;
  }
});

export const BusinessInfoSave = createAsyncThunk("post/save", async (props) => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const { userName, payload } = props;

    const response = await fetch(
      `${proxy}/businessInfoConfig/saveOrUpdateBusinessConfigInfo/${userName}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
    );
    handleResponseCode(response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});

export const Businessdelete = createAsyncThunk(
  "post/deleteinfo",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { userName, id } = props;
      const response = await fetch(
        `${proxy}/businessInfoConfig/delete/${id}/${userName}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

export const BusinessEdit = createAsyncThunk(
  "post/getdataedit",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { id } = props;
      const response = await fetch(`${proxy}/businessInfoConfig/${id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      });
      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);
export const getTableFilter = createAsyncThunk(
  "post/getTableFilter",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(`${proxy}/businessInfoConfig/list/BusinessInfoConfig/division`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      });
      handleResponseCode(response);
      const data = await response.json();

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
);
export const userInfoListApi = createAsyncThunk(
  "post/userInfoListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(`${proxy}/LDAPDashboard/userInformationForCmdbList/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const serverInfoListApi = createAsyncThunk(
  "post/serverInfoListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(`${proxy}/serverConfigInfo/devicesDetailsList/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);


export const cloudAccountListApi = createAsyncThunk(
  "post/cloudAccountListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(`${proxy}/awsIam/getMasterCloudAccountsDetailsList/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const cloudAccountCountApi = createAsyncThunk(
  "post/cloudAccountCountApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(`${proxy}/awsIam/CSPAccountListForSearchCount`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const cloudAccountTestConnection = createAsyncThunk(
  "post/cloudAccountTestConnection",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(`${proxy}/awsIam/checkAccountForTestConnection`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(props),
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const osLicenseConfigListApi = createAsyncThunk(
  "post/osLicenseConfigListApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(`${proxy}/licenceConfigForServerRest/getListWithSearchAndPagination/${pageNumber}/${itemsPerPage}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const osLicenseConfigCountApi = createAsyncThunk(
  "post/osLicenseConfigCountApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(`${proxy}/licenceConfigForServerRest/getListCountWithSearchAndPagination`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const isLdapUserCheckAPI = createAsyncThunk(
  "post/isLdapUserCheckAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(`${proxy}/LDAPDashboard/checkLDAPConfig`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const ldapSyncAPI = createAsyncThunk(
  "post/ldapSyncAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(`${proxy}/LDAPDashboard/LDAPDashboardDataSave`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getServerConfigDetails = createAsyncThunk(
  "get/getServerConfigDetails",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");

    const { ip } = props;
    try {
      const response = await fetch(`${proxy}/tenableAdvanceScan/getByIP/${ip}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
      }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const SaveServerConfig = createAsyncThunk("post/SaveServerConfig", async (props) => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const { payload } = props;

    const response = await fetch(
      `${proxy}/tenableAdvanceScan/saveOrUpdate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      }
    );
    handleResponseCode(response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});

export const getSonarProjectListAPI = createAsyncThunk("get/getSonarProjectListAPI", async () => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const response = await fetch(`${proxy}/jiraProjectListRest/list/sonarQubeProjectList`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "DTOP-API-TOKEN": apiToken,
        USERNAME: username,
      },
    });
    handleResponseCode(response);
    const data = await response.json();
    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("error:", error);
    throw error;
  }
});

export const exportCmdbAppConfigCSV = createAsyncThunk(
  "post/exportCmdbAppConfigCSV",
  async (payload) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/cmdb/exportCmdbAppConfigCSV`,
        {
          method: "POST",
          headers: {
            Accept: "application/octet-stream",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload), 
        }
      );
      const data = await response.blob();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);





const CMDBSlice = createSlice({
  name: "CmdbId",
  initialState: {
    getCmdbId: "",
    businessInfoData: [],
    bILoading: false,
    Applist: [],
    ApplistLoading: false,
    saveLoading: false,
    DataSave: "",
    deleteLoading: false,
    editLoading: false,
    responseData: [],
    tableFilterData: [],
    error: "",
    errorEdit: "",
    errorCount: "",
    errorApp: "",
    errorSave: "",
    errorDelete: "",
    DataDelete: {},
    userInfoListLoading: false,
    userInfoListData: [],
    userInfoCountLoading: false,
    userInfoCountData: [],
    serverInfoListLoading: false,
    serverInfoListData: [],
    cloudAccountListLoading: false,
    cloudAccountListData: [],
    cloudAccountCountLoading: false,
    cloudAccountCountData: [],
    osLicenseConfigListLoading: false,
    osLicenseConfigListData: [],
    osLicenseConfigCountLoading: false,
    osLicenseConfigCountData: [],
    isLdapUser: false,
    isLdapUserLoading: false,
    ldapSyncdata: [],
    ldapSyncLoading: false,
    ldapSyncdataFulFill: false,
    alertError : false,
    userSearchListLoading:false,
    userSearchListData:[],
    saveReviewerConfigurationLoading:false,
    saveReviewerConfigurationData:[],
    reviewersListLoading:false,
    reviewersListData:[],
    reviewConfigurationLoading:false,
    reviewConfigurationData:[],
    serverConfigData : [],
    serverConfigLoading : false,
    serverConfogSaveData : [],
    serverConfigSaveDataLoading : false,
    projectListData : [],
    projectListDataLoading : false,
    GitlabprojectListData : [],
    GitlabprojectListDataLoading : false,
    getSonarProjectListData : [],
    getSonarProjectListLoading : false,
    exportCSVListLoading:false,
    exportCSVData:[],
    smtptoggleLoading: false,

  },
  reducers: {
    setCmdbId: (state, action) => {
      state.getCmdbId = action.payload;
    },
    setalertError: (state) => {
      state.alertError = false;
    },
    resetDataSave: (state) => {
      state.DataSave = "";
    },
    resetldapSyncStatus: (state) => {
      state.ldapSyncdataFulFill = false;
      state.ldapSyncdata = '';
    },
    resetresponseData: (state) => {
      state.responseData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(businessInfoList.pending, (state) => {
        state.bILoading = true;
        state.alertError = false;
      })
      .addCase(businessInfoList.fulfilled, (state, action) => {
        state.businessInfoData = action.payload;
        state.bILoading = false;
        state.alertError = false;
      })
      .addCase(businessInfoList.rejected, (state) => {
        state.bILoading = false;
        state.businessInfoData = [];
        state.error = "Something went wrong";
        state.alertError = true;
      })

      .addCase(AppList.pending, (state) => {
        state.ApplistLoading = true;
        state.alertError = false;
      })
      .addCase(AppList.fulfilled, (state, action) => {
        state.Applist = action.payload;
        state.ApplistLoading = false;
        state.alertError = false;
      })
      .addCase(AppList.rejected, (state) => {
        state.ApplistLoading = false;
        state.Applist = [];
        state.errorApp = "Something went wrong";
        state.alertError = true;
      })

      .addCase(BusinessInfoSave.pending, (state) => {
        state.DataSave = "";
        state.saveLoading = true;
        state.alertError = false;
      })
      .addCase(BusinessInfoSave.fulfilled, (state, action) => {
        state.DataSave = action.payload;
        state.saveLoading = false;
        state.alertError = false;
      })
      .addCase(BusinessInfoSave.rejected, (state) => {
        state.saveLoading = false;
        state.DataSave = "";
        state.errorSave = "Something went wrong";
        state.alertError = true;
      })

      .addCase(Businessdelete.pending, (state,) => {
        state.deleteLoading = true;
        state.alertError = false;
      })
      .addCase(Businessdelete.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.DataDelete = action.payload;
        state.alertError = false;
      })
      .addCase(Businessdelete.rejected, (state) => {
        state.deleteLoading = false;
        state.errorDelete = "Something went wrong";
        state.alertError = true;
      })

      .addCase(BusinessEdit.pending, (state) => {
        state.editLoading = true;
        state.alertError = false;
      })
      .addCase(BusinessEdit.fulfilled, (state, action) => {
        state.responseData = action.payload;
        state.editLoading = false;
        state.alertError = false;
      })
      .addCase(BusinessEdit.rejected, (state) => {
        state.editLoading = false;
        state.responseData = [];
        state.errorEdit = "Something went error";
        state.alertError = true;
      })

      .addCase(getTableFilter.fulfilled, (state, action) => {
        state.tableFilterData = action.payload;
        state.alertError = false;
      })

      // userInfo List
      .addCase(userInfoListApi.pending, (state) => {
        state.userInfoListLoading = true;
        state.alertError = false;
      })
      .addCase(userInfoListApi.fulfilled, (state, action) => {
        state.userInfoListData = action.payload;
        state.userInfoListLoading = false;
        state.ldapSyncdata = [];
        state.ldapSyncdataFulFill = false;
        state.alertError = false;
      })
      .addCase(userInfoListApi.rejected, (state) => {
        state.userInfoListLoading = false;
        state.userInfoListData = [];
        state.ldapSyncdata = [];
        state.ldapSyncdataFulFill = false;
        state.alertError = true;
      })

      // serverInfo List
      .addCase(serverInfoListApi.pending, (state) => {
        state.serverInfoListLoading = true;
        state.alertError = false;
      })
      .addCase(serverInfoListApi.fulfilled, (state, action) => {
        state.serverInfoListData = action.payload;
        state.serverInfoListLoading = false;
        state.alertError = false;
      })
      .addCase(serverInfoListApi.rejected, (state) => {
        state.serverInfoListLoading = false;
        state.serverInfoListData = [];
        state.alertError = true;
      })

      // cloudAccount List
      .addCase(cloudAccountListApi.pending, (state) => {
        state.cloudAccountListLoading = true;
        state.alertError = false;
      })
      .addCase(cloudAccountListApi.fulfilled, (state, action) => {
        state.cloudAccountListData = action.payload;
        state.cloudAccountListLoading = false;
        state.alertError = false;
      })
      .addCase(cloudAccountListApi.rejected, (state) => {
        state.cloudAccountListLoading = false;
        state.cloudAccountListData = [];
        state.alertError = true;
      })

      .addCase(cloudAccountCountApi.pending, (state) => {
        state.cloudAccountCountLoading = true;
        state.alertError = false;
      })
      .addCase(cloudAccountCountApi.fulfilled, (state, action) => {
        state.cloudAccountCountData = action.payload;
        state.cloudAccountCountLoading = false;
        state.alertError = false;
      })
      .addCase(cloudAccountCountApi.rejected, (state) => {
        state.cloudAccountCountLoading = false;
        state.cloudAccountCountData = [];
        state.alertError = true;
      })
      // osLicenseConfig List
      .addCase(osLicenseConfigListApi.pending, (state) => {
        state.osLicenseConfigListLoading = true;
        state.alertError = false;
      })
      .addCase(osLicenseConfigListApi.fulfilled, (state, action) => {
        state.osLicenseConfigListData = action.payload;
        state.osLicenseConfigListLoading = false;
        state.alertError = false;
      })
      .addCase(osLicenseConfigListApi.rejected, (state) => {
        state.osLicenseConfigListLoading = false;
        state.osLicenseConfigListData = [];
        state.alertError = true;
      })

      .addCase(osLicenseConfigCountApi.pending, (state) => {
        state.osLicenseConfigCountLoading = true;
        state.alertError = false;
      })
      .addCase(osLicenseConfigCountApi.fulfilled, (state, action) => {
        state.osLicenseConfigCountData = action.payload;
        state.osLicenseConfigCountLoading = false;
        state.alertError = false;
      })
      .addCase(osLicenseConfigCountApi.rejected, (state) => {
        state.osLicenseConfigCountLoading = false;
        state.osLicenseConfigCountData = [];
        state.alertError = true;
      })

      .addCase(isLdapUserCheckAPI.pending, (state) => {
        state.isLdapUserLoading = true;
        state.alertError = false;
      })
      .addCase(isLdapUserCheckAPI.fulfilled, (state, action) => {
        state.isLdapUser = action.payload;
        state.isLdapUserLoading = false;
        state.alertError = false;
      })
      .addCase(isLdapUserCheckAPI.rejected, (state) => {
        state.isLdapUserLoading = false;
        state.isLdapUser = [];
        state.alertError = true;
      })

      .addCase(ldapSyncAPI.pending, (state) => {
        state.ldapSyncLoading = true;
        state.alertError = false;
      })
      .addCase(ldapSyncAPI.fulfilled, (state, action) => {
        state.ldapSyncdata = action.payload;
        state.ldapSyncdataFulFill = true;
        state.ldapSyncLoading = false;
        state.alertError = false;
      })
      .addCase(ldapSyncAPI.rejected, (state) => {
        state.ldapSyncLoading = false;
        state.ldapSyncdata = [];
        state.alertError = true;
      })

      .addCase(getServerConfigDetails.pending, (state) => {
        state.serverConfigLoading = true;
        state.alertError = false;
      })
      .addCase(getServerConfigDetails.fulfilled, (state, action) => {
        state.serverConfigData = action.payload;
        state.serverConfigLoading = false;
        state.alertError = false;
      })
      .addCase(getServerConfigDetails.rejected, (state) => {
        state.serverConfigLoading = false;
        state.serverConfigData = [];
        state.alertError = true;
      })

      .addCase(SaveServerConfig.pending, (state) => {
        state.serverConfigSaveDataLoading = true;
        state.alertError = false;
      })
      .addCase(SaveServerConfig.fulfilled, (state, action) => {
        state.serverConfogSaveData = action.payload;
        state.serverConfigSaveDataLoading = false;
        state.alertError = false;
      })
      .addCase(SaveServerConfig.rejected, (state) => {
        state.serverConfigSaveDataLoading = false;
        state.serverConfogSaveData = [];
        state.alertError = true;
      })

      //SonarQube
      .addCase(getSonarProjectListAPI.pending, (state) => {
        state.getSonarProjectListLoading = true;
        state.alertError = false;
      })
      .addCase(getSonarProjectListAPI.fulfilled, (state, action) => {
        state.getSonarProjectListData = action.payload;
        state.getSonarProjectListLoading = false;
        state.alertError = false;
      })
      .addCase(getSonarProjectListAPI.rejected, (state) => {
        state.getSonarProjectListLoading = false;
        state.getSonarProjectListData = [];
        state.alertError = true;
      })

        //ExportCSV
      .addCase(exportCmdbAppConfigCSV.pending, (state) => {
        state.exportCSVListLoading = true;
        state.alertError = false;
      })
      .addCase(exportCmdbAppConfigCSV.fulfilled, (state) => {
        state.exportCSVListLoading = false;
        state.alertError = false;
      })
      .addCase(exportCmdbAppConfigCSV.rejected, (state) => {
        state.exportCSVListLoading = false;
        state.exportCSVData = [];
        state.alertError = true;
      });

  },
});

export const { setCmdbId, resetDataSave, resetresponseData, resetldapSyncStatus, setalertError } =
  CMDBSlice.actions;
export default CMDBSlice.reducer;
